import React from 'react';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';

export default createReactClass({
  displayName: 'Root',
  propTypes: {
    previewContent: PropTypes.object.isRequired,
    modalContent: PropTypes.object.isRequired,
    isActive: PropTypes.bool,
  },
  getInitialState() {
    return {
      isActive: this.props.isActive,
      fadeClassName: 'modal-view-fade-in',
      scrollPos: 0,
      isChangeElements: false,
      isReturnElements: false,
    };
  },
  changeElements() {
    const modalView = document.getElementById('modal-view');
    if (modalView && this.state.isChangeElements === false) {
      var window = document.getElementById('bg-boxed');
      $(window).append(modalView);
      this.setState({
        isChangeElements: true,
      });
    }
  },
  returnElements() {
    if (this.state.isChangeElements) {
      const returnElements = document.getElementById('return-elements');
      const returnPlace = document.getElementById('return-place');
      $(returnPlace).append(returnElements);
      this.setState({
        isChangeElements: false,
        isReturnElements: false,
      });
    }
  },
  openModal() {
    var scrollPos = window.pageYOffset;
    var marginLeft =
      (window.innerWidth - $('.royal_preloader .container').outerWidth()) / 2;
    var width = window.innerWidth > 767 ? '' : '100%';
    $('body').css({
      position: 'fixed',
      marginTop: -scrollPos,
      marginLeft: marginLeft,
      width: width,
    });
    this.setState({
      fadeClassName: 'modal-view-fade-in',
      isActive: true,
      scrollPos: scrollPos,
    });
  },
  closeModal() {
    $('body').css({
      position: 'relative',
      marginTop: '0',
      marginLeft: '0',
      width: '',
    });
    $(window).scrollTop(this.state.scrollPos);
    this.setState({
      fadeClassName: 'modal-view-fade-out',
    });
    // setTimeout(function () {
    this.setState({
      isActive: false,
      isReturnElements: true,
    });
    // }.bind(this), 300);
  },
  handleRejectButton() {
    if (this.props.rejectFunc != undefined) {
      this.props.rejectFunc();
    }
    this.closeModal();
  },
  handleModalContent() {
    this.openModal();
  },
  componentDidUpdate() {
    this.changeElements();
    this.state.isReturnElements || this.state.isActive === false
      ? this.returnElements()
      : '';
  },
  componentWillUnmount() {
    this.closeModal();
  },
  render() {
    const previewContent = this.props.previewContent;
    return (this.state.isActive && this.props.isActive) ||
      (this.state.isActive && this.props.isActive == undefined) ? (
      <div id={this.state.isChangeElements ? 'return-place' : ''}>
        <div onClick={this.handleModalContent} className="cursor-pointer">
          {previewContent}
        </div>
        <div className="modal-view">
          <div className={this.state.fadeClassName}>
            <div className="modal-view-overAll">
              <div
                className="modal-view-overlay"
                onClick={this.handleRejectButton}
              >
                <div className="modal-xBtn font-size-28 cursor-pointer">×</div>
              </div>
              <div className="modal-view-large-dialog">
                <div className="modal-view-content">
                  {this.props.modalContent}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    ) : (
      <div id={this.state.isChangeElements ? 'return-place' : ''}>
        <div id={this.state.isChangeElements ? 'return-elements' : ''}>
          <div onClick={this.handleModalContent} className="cursor-pointer">
            {previewContent}
          </div>
        </div>
      </div>
    );
  },
});
